import { Component, Input } from '@angular/core';
import { NucampanalyticsService } from '../../services/nucampanalytics/nucampanalytics.service';
import { NavigateService } from '../../services/navigate/navigate.service';
import { RouterLink } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { NgIf, NgStyle } from '@angular/common';

/**
 * Generated class for the FeaturedonComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    styleUrls: ['./featuredon.scss'],
    selector: 'featuredon',
    templateUrl: 'featuredon.html',
    standalone: true,
    imports: [NgIf, IonicModule, RouterLink, NgStyle]
})
export class FeaturedonComponent {
  @Input() feature: string[];
  @Input() excludeNumber1: boolean;

  constructor(
    private nucampnav: NavigateService,
    public nucampAnalytics: NucampanalyticsService
  ) { }

  openPage(page) {
    this.nucampnav.openPage(page);
  }

  ionViewDidLeave() {
    // console.log("YouTube Components", this.YTs)
  }

}

